var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{class:( _obj = {}, _obj[_vm.$c('layout-footer')] = true, _obj[_vm.$c('layout-footer-sticky')] = _vm.sticky, _obj )},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }